<template>
  <el-container id="tab">
    <el-aside :width="isCollapse ? '20px' : '300px'">
      <el-card v-show="!isCollapse" class="box-card" shadow="never">
        <div slot="header">
          <span>商品类别</span>
          <el-button style="float: right; padding: 3px 0" icon="el-icon-d-arrow-left" type="text" @click="isCollapse = !isCollapse"></el-button>
        </div>
        <el-cascader-panel
          v-model="cascaderSelect"
          :options="cascaderData"
          @expand-change="handleExpandChange"
          @change="handleChange"
        >
          <template slot-scope="{ data }">
            <span>{{ data.text }}</span>
          </template>
        </el-cascader-panel>
      </el-card>
      <div class="is-collapse" v-show="isCollapse" @click="isCollapse = !isCollapse">
        <span style="text-align: center;">商品</span>
        <el-button icon="el-icon-d-arrow-right" type="text"></el-button>
        <span style="text-align: center;">类别</span>
      </div>
    </el-aside>
    <el-main>
      <div class="el-card main">
        <el-card class="box-card" shadow="never">
          <el-form :inline="true" size="small">
            <el-form-item label="查询条件">
              <el-input v-model="productArgs.itemName" placeholder="请输入商品名称检索" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="getProductData">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="onSubmit">保存</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="toJump">价格方案</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="success" style="padding: 0;"><el-link style="color: #FFFFFF; font-size: 12px; line-height: 31px; padding: 0 15px;" :underline="false" :href="`/erpnew/account/c/reada46ceb/excel/export/itemPrice?brandId=${productArgs.brandID}&itemTypeId=${productArgs.itemTypeID}&searchOpt=${productArgs.itemName}`">导出</el-link></el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="success" @click="dialogImportVisible = true">导入</el-button>
            </el-form-item>
          </el-form>
        </el-card>
        <div class="table">
          <el-table ref="table" v-loading="tableLabelLoading || tableLoading" :data="productList" border stripe height="100%" max-height="100%" size="mini" :cell-class-name="cellClassName" @cell-click="tableCellClick">
            <el-table-column type="index" width="50" fixed :index="indexMethod"></el-table-column>
            <el-table-column label="商品名称" width="200" fixed prop="itemName"></el-table-column>
            <el-table-column label="规格" prop="unitChangerStr" fixed></el-table-column>
            <el-table-column v-for="item in tableLabelList" :key="item.prop" :label="item.label" align="center" :prop="item.prop">
              <el-table-column width="100" v-for="$item in item.children" :key="$item.prop" :label="$item.label" :prop="$item.prop" :class-name="$item.prop" :label-class-name="item.prop">
                <template slot-scope="{ row, column }">
                  <el-input-number v-if="(getItemForArr(row, item.prop))[item.prop + '_' + $item.prop]" style="width: 100%;" size="mini" v-focus v-model.number="getItemForArr(row, item.prop)[$item.prop]" :controls="false" :min="0" :precision="4" @blur="inputNumberBlur(row, column)" @change="inputNumberChange(row)" @input="handleInput($event, row, column)"></el-input-number>
                  <div v-else>
                    <span>{{Number((Number(getItemForArr(row, item.prop) ? getItemForArr(row, item.prop)[$item.prop] : 0) || 0).toFixedRoundUp(4)) || ''}}</span>
                    <span v-if="getItemForArr(row, item.prop)[$item.prop] > 0">元/{{row[$item.prop.replace('Price', 'Name')]}}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="productArgs.page" :page-sizes="[10, 20, 100]" :page-size="productArgs.size" layout="total, sizes, prev, pager, next, jumper" :total="productTotal"></el-pagination>
      </div>
    </el-main>
    <el-dialog title="导入" :visible.sync="dialogImportVisible" width="400px" @close="dialogImportColse">
      <template>
        <import-template
          v-if="dialogImportVisible"
          :downloadTemplateURL="`/erpnew/account/c/reada46ceb/excel/export/itemPrice?brandId=${productArgs.brandID}&itemTypeId=${productArgs.itemTypeID}&searchOpt=${productArgs.itemName}&fileName=价格信息模板.xlsx`"
          downloadTemplateName="价格信息模板"
          :importExcelURL="'/erpnew/account/c/reada46ceb/excel/import/itemPrice'"
          :type="'priceManagement'"
          :isNew="true"
          @import-close="dialogImportColse"
        >
        </import-template>
      </template>
    </el-dialog>
  </el-container>
</template>

<script>
import { toFixedRe } from '@/assets/js/common.js'
import importTemplate from '@/components/common/importTemplate.vue'
export default {
  name: 'priceManagement',
  props: ['itemName'],
  components: {
    importTemplate
  },

  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('input').onfocus = function (e) {
          e.currentTarget.select()
        }
        el.querySelector('input').focus()
      }
    }
  },
  data() {
    return {
      isCollapse: false,
      brandArgs: {
        url: "/Account/dataSearch/selectBrandListForVue.html",
        isPage: 'N'
      },
      brandTypeArgs: {
        url: "/Account/dataSearch/selectTypeListForVue.html",
        brandID: "",
        isPage: 'N'
      },
      productArgs: {
        page: 1,
        size: 10,
        brandID: "",
        itemTypeID: "",
        itemName: this.itemName ? this.itemName : "",
        url: "/Account/PricePlan/selectItemPricePlanByParam.html",
      },
      cascaderSelect: ["", ""],
      cascaderData: [],
      tableLabelLoading: false,
      tableLoading: false,
      productTotal: 0,
      productList: [],
      tableLabelList: [],
      selectProductList: [],
      dialogImportVisible: false
    }
  },
  created() {
    this.getBrandData();
    this.getTableLabel();
    this.getProductData();
  },
  methods: {
    async getTableLabel() {
      this.tableLabelLoading = true
      const { data: res } = await this.$http.post('/Account/PricePlan/selectPricePlanColumn.html')
      res.result = JSON.parse(res.result);
      if (res.code != "success") return this.$message.error(res.message);
      this.tableLabelLoading = false
      this.tableLabelList = JSON.parse(res.result.data);
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
    async getBrandData() {
      const { data: res } = await this.$http.post(this.brandArgs.url, this.Qs.stringify(this.brandArgs))
      if (res.code != "success") return this.$message.error(res.message);
      res.result = JSON.parse(res.result);
      let arr = JSON.parse(res.result.data);
      this.cascaderData = [];
      arr.forEach(item => {
        this.cascaderData.push({
          text: item.text,
          value: item.value,
          children: [
            {
              value: "",
              text: "全部",
            }
          ]
        })
      });
      this.cascaderData.unshift({
        value: "",
        text: "全部",
        children: [
          {
            value: "",
            text: "全部",
          },
        ],
      });
    },
    async getBrandTypeData(brand) {
      if (!brand) return false;
      const { data: res } = await this.$http.post(this.brandTypeArgs.url, this.Qs.stringify(this.brandTypeArgs));
      if (res.code != "success") return false;
      res.result = JSON.parse(res.result);
      this.cascaderData.some((item, index) => {
        if (item.value == brand) {
          this.cascaderData[index].children = JSON.parse(res.result.data);
          this.cascaderData[index].children.unshift({
            value: "",
            text: "全部",
          });
          return true;
        }
      });
    },
    handleExpandChange(value) {
      this.$set(this.cascaderSelect, 0, value[0]);
      this.$set(this.cascaderSelect, 1, "");
      this.brandTypeArgs.brandID = value[0];
      this.getBrandTypeData(value[0]);
      this.productArgs.page = 1;
      this.getProductData();
    },
    handleChange(value) {
      this.cascaderSelect = value;
      this.productArgs.page = 1;
      this.getProductData();
    },
    async getProductData() {
      this.productArgs.brandID = this.cascaderSelect[0]
      this.productArgs.itemTypeID = this.cascaderSelect[1]
      this.tableLoading = true
      const { data: res } = await this.$http.post(this.productArgs.url, this.Qs.stringify(this.productArgs))
      this.tableLoading = false
      if (res.code != 'success') return this.$message.error(res.message)
      res.result = JSON.parse(res.result)
      this.productList = JSON.parse(res.result.data)
      this.productTotal = res.result.total
      this.$nextTick(() => {
        this.$refs.table.doLayout()
      })
    },
     // 监听pagesize的改变
    handleSizeChange(newSize) {
      this.productArgs.size = newSize
      this.getProductData()
    },
    // 监听页码值的改变
    handleCurrentChange(newPage) {
      this.productArgs.page = newPage
      this.getProductData()
    },
    indexMethod(index) {
      return ((this.productArgs.page - 1) * this.productArgs.size) + (index + 1)
    },
    cellClassName({ row }) {
      if (row.midUnitConversion == 0) {
        return 'disable'
      }
      return ''
    },
    getItemForArr(row, pricePlan) {
      let arr = row.children ? row.children.filter(i => i.pricePlan == pricePlan) : []
      return arr.length ? arr[0] : {}
    },
    tableCellClick(row, { property, labelClassName }) {
      if (!['salUnitPrice', 'midUnitPrice', 'invUnitPrice'].includes(property)) return false
      if (property == 'midUnitPrice' && row.midUnitConversion == 0) return false
      let index = row.children.findIndex(i => i.pricePlan == labelClassName)
      if (index == -1) {
        let item = {
          pricePlan: labelClassName,
          invUnitName: row.invUnitName,
          invUnitPrice: '',
          midUnitName: row.midUnitName,
          salUnitName: row.salUnitName,
          salUnitPrice: '',
        }
        item[labelClassName + '_' + property] = true
        row.children.push(item)
        this.$refs.table.doLayout()
      } else {
        this.$set(row.children[index], labelClassName + '_' + property, true)
      }
    },
    inputNumberBlur(row, { property, labelClassName }) {
      let index = row.children.findIndex(i => i.pricePlan == labelClassName)
      if (index > -1) {
        this.$set(row.children[index], labelClassName + '_' + property, false)
        this.$nextTick(() => {
          delete row.children[index][labelClassName + '_' + property]
        })
      }
    },
    inputNumberChange(row) {
      let index = this.selectProductList.findIndex(i => i.itemID == row.itemID)
      if (index != -1) {
        this.selectProductList[index] = { ...row }
      } else {
        this.selectProductList.push(row)
      }
    },
    async onSubmit() {
      if (this.selectProductList.length == 0) {
        return this.$message.warning('请在修改后保存！')
      }
      const { data: res } = await this.$http.post('/Account/PricePlan/updateItemPricePlan.html', this.Qs.stringify({ itemPriceList: JSON.stringify(this.selectProductList) }))
      if (res.code != 'success') return this.$message.error(res.message)
      this.$message.success(res.message)
      this.selectProductList = []
      this.getProductData()
    },
    handleInput (val, row, { property, labelClassName }) {
      let childrenRow = this.getItemForArr(row, labelClassName)
      if (val) {
        val = toFixedRe(val, 4)
      }
      this.computeUnitPrice(property, row, childrenRow)
    },
    computeUnitPrice (property, row, childrenRow) {
      let { salUnitPrice, midUnitPrice, invUnitPrice } = childrenRow
      let { salUnitConversion, midUnitConversion } = row
      if (property == 'salUnitPrice') {
        midUnitPrice = Number(toFixedRe((Number(salUnitPrice) || 0) / Number(salUnitConversion) * Number(midUnitConversion), 4)).toString()
        invUnitPrice = Number(toFixedRe((Number(salUnitPrice) || 0) / Number(salUnitConversion), 4)).toString()
      } else if (property == 'midUnitPrice') {
        salUnitPrice = Number(toFixedRe((Number(midUnitPrice) || 0) / Number(midUnitConversion) * Number(salUnitConversion), 4)).toString()
        invUnitPrice = Number(toFixedRe((Number(midUnitPrice) || 0) / Number(midUnitConversion), 4)).toString()
      } else if (property == 'invUnitPrice') {
        salUnitPrice = Number(toFixedRe((Number(invUnitPrice) || 0) * Number(salUnitConversion), 4)).toString()
        midUnitPrice = Number(toFixedRe((Number(invUnitPrice) || 0) * Number(midUnitConversion), 4)).toString()
      }
      childrenRow.salUnitPrice = salUnitPrice
      childrenRow.midUnitPrice = midUnitPrice
      childrenRow.invUnitPrice = invUnitPrice
    },
    toJump() {
      let width = top.document.browser.availiframeWidth.value
      let height = top.document.browser.availiframeHeight.value
      top.addPanel('价格方案定义', '/templates/vue-account/dist/index.htm#/PriceDefinition', width, height, true)
    },
    dialogImportColse(data) {
      let type = data ? data.type : ''
      console.log(data)
      this.dialogImportVisible = false
      if (type == 1) {
        this.productArgs.page = 1
        this.getTableLabel();
        this.getProductData();
      }
    }
  }
}
</script>

<style scoped lang="less">
#tab {
  .el-aside {
    .box-card {
      height: calc(100% - 2px);
      ::v-deep .el-card__header {
        padding: 8px 20px;
        height: 33px;
      }
      ::v-deep .el-card__body {
        padding: 0;
        height: calc(100% - 33px);
        .el-cascader-panel {
          width: 100%;
          height: 100%;
          display: flex;
          border: none;
          .el-cascader-menu {
            flex: 1;
            min-width: 0;
            .el-cascader-menu__wrap {
              height: 100%;
              overflow-x: hidden;
            }
          }
        } 
      }
    }
    .is-collapse {
      width: calc(100% - 2px);
      height: calc(100% - 2px);
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: center;
      border: 1px #DCDFE6 solid;
      cursor: pointer;
      background-color: rgba(83, 168, 255, 0.1);
      color: #409EFF;
    }
  }
  .el-main {
    padding: 0 0 0 6px;
    box-sizing: border-box;
    .main {
      height: 100%;
      box-sizing: border-box;
      padding: 12px;
      ::v-deep .box-card {
        .el-card__body {
          padding: 10px 15px;
          .el-form {
            .el-form-item {
              margin-bottom: 0;
            }
          }
        }
      }
      .table {
        height: calc(100% - 53px - 32px);
        ::v-deep .el-table  {
          .el-table__body-wrapper {
            .midUnitPrice.disable {
              background-color: #F2F6FC;
            }
            .cell {
              min-height: 30px;
              display: flex;
              align-items: center;
            }
          }
          .el-table__fixed-body-wrapper {
            .cell {
              min-height: 30px;
              display: flex;
              align-items: center;
            }
          }
          .el-input-number.is-without-controls .el-input__inner {
            padding: 0 6px;
          }
        }
      }
    }
  }
}
</style>